'use client'

import inabooth_group from '@/app/_components/Section/LicensingSolution/inabooth_group.png'
import I18nTranslator from '@/app/_components/Shared/I18nTranslator/I18nTranslatorClient'
import { Button } from '@/app/_primitives/Button'
import Image from 'next/image'
import Link from 'next/link'
import { usePathname } from 'next/navigation'

export default function LicensingSolution() {
  const pathname = usePathname()

  return (
    <div className="container py-100">
      <div className="relative flex flex-col items-center gap-56 max-lg:items-start xl:flex-row xl:justify-center xl:gap-80">
        <div className="relative flex flex-col gap-32 max-sm:items-center">
          <div className="b-h3">
            {<I18nTranslator text="common.licensingSolution" />}
          </div>
          <div className="c-b2 lg:c-b1">
            <div>{<I18nTranslator text="common.licensingDesc1" />}</div>
            <div>{<I18nTranslator text="common.licensingDesc2" />}</div>
          </div>
          {pathname === '/licensing' ? null : (
            <Button
              asChild
              type="button"
              color="frenchBlue"
              size="default"
              className="w-166">
              <Link href={'/licensing'}>
                {<I18nTranslator text="common.viewCollection" />}
              </Link>
            </Button>
          )}
        </div>
        <div className="relative max-lg:aspect-[10/7] max-lg:w-full lg:h-330 lg:w-472">
          <Image src={inabooth_group} fill alt="inabooth_group" />
        </div>
      </div>
    </div>
  )
}
